import SignupAlbumCreate from './SignupAlbumCreate';

export default SignupAlbumCreate;
